import React from "react";

import {
    useHistory
}
from "react-router-dom";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faTimes,
    faHome,
    faUser,
    faQuestion,
    faHeart,
    faPaperclip,
    faArrowLeft,
    faCogs,
    faSignOutAlt
}
from "@fortawesome/free-solid-svg-icons";


//============================================================
// Mobile Menu
//============================================================

export default function MobileMenu(
{
    show,
    close,
    showAdmin = true
})
{

    //--------------------------------------------------------
    // Navigation
    //--------------------------------------------------------

    const history =
        useHistory();


    const goHome =
        function()
        {
            history.push(
                "/home"
            );
        };


    const goProfile =
        function()
        {
            console.log(
                "PROFILE"
            );
        };


    const goHelp =
        function()
        {
            console.log(
                "HELP"
            );
        };


   


    const goBack =
        function()
        {
            history.goBack();
        };


   


    const goLogout =
        function()
        {
            history.push(
                "/logout"
            );
        };


    //--------------------------------------------------------
    // Display
    //--------------------------------------------------------

    if(!show)
    {
        return null;
    }


    //========================================================
    // Styles
    //========================================================

    const overlay =
    {
        position:
            "fixed",

        inset:
            0,

        zIndex:
            9000,

        background:
            "rgba(0,0,0,0.28)",

        backdropFilter:
            "blur(3px)",

        WebkitBackdropFilter:
            "blur(3px)"
    };


    const drawer =
    {
        position:
            "absolute",

        top:
            0,

        right:
            0,

        width:
            "280px",

        maxWidth:
            "82vw",

        height:
            "100%",

        background:
            "linear-gradient(180deg,#1f2937 0%,#111827 100%)",

        boxShadow:
            "-12px 0 30px rgba(0,0,0,0.28)",

        display:
            "flex",

        flexDirection:
            "column",

        boxSizing:
            "border-box"
    };


    const header =
    {
        height:
            "62px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "space-between",

        padding:
            "0 18px",

        borderBottom:
            "1px solid rgba(255,255,255,0.10)"
    };


    const headerTitle =
    {
        color:
            "#ffffff",

        fontSize:
            "15px",

        fontWeight:
            "600"
    };


    const closeButton =
    {
        width:
            "36px",

        height:
            "36px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        borderRadius:
            "50%",

        background:
            "rgba(255,255,255,0.08)",

        color:
            "#ffffff",

        cursor:
            "pointer"
    };


    const items =
    {
        padding:
            "12px 10px"
    };


    //========================================================
    // Menu item
    //========================================================

    function menuItem(
        icon,
        label,
        clickFunction
    )
    {

        return (

            <div
                onClick={
                    function()
                    {

                        close();

                        if(clickFunction)
                        {
                            clickFunction();
                        }

                    }
                }

                style={{
                    height:
                        "52px",

                    display:
                        "flex",

                    alignItems:
                        "center",

                    padding:
                        "0 12px",

                    color:
                        "#ffffff",

                    cursor:
                        "pointer",

                    borderBottom:
                        "1px solid rgba(255,255,255,0.06)"
                }}
            >

                <div
                    style={{
                        width:
                            "36px",

                        height:
                            "36px",

                        display:
                            "flex",

                        alignItems:
                            "center",

                        justifyContent:
                            "center",

                        marginRight:
                            "12px",

                        borderRadius:
                            "50%",

                        background:
                            "rgba(255,255,255,0.08)"
                    }}
                >

                    <FontAwesomeIcon
                        icon={icon}
                    />

                </div>


                <span
                    style={{
                        fontSize:
                            "13px",

                        fontWeight:
                            "500"
                    }}
                >

                    {label}

                </span>

            </div>

        );

    }


    //========================================================
    // Render
    //========================================================

    return (

        <div
            style={overlay}
            onClick={close}
        >

            <div
                style={drawer}

                onClick={
                    function(event)
                    {
                        event.stopPropagation();
                    }
                }
            >

                <div style={header}>

                    <div style={headerTitle}>
                        Menu
                    </div>

                    <div
                        style={closeButton}
                        onClick={close}
                    >

                        <FontAwesomeIcon
                            icon={faTimes}
                        />

                    </div>

                </div>


                <div style={items}>

                    {
                        menuItem(
                            faHome,
                            "Home",
                            goHome
                        )
                    }

                    {
                        menuItem(
                            faUser,
                            "Profile",
                            goProfile
                        )
                    }

                    {
                        menuItem(
                            faQuestion,
                            "Help",
                            goHelp
                        )
                    }

                  

                    {
                        menuItem(
                            faArrowLeft,
                            "Back",
                            goBack
                        )
                    }


                    {
                        menuItem(
                            faSignOutAlt,
                            "Log Out",
                            goLogout
                        )
                    }

                </div>

            </div>

        </div>

    );

}